import React, { createContext, FC, useMemo } from 'react';
import { useGetConfigs } from '../hooks/queries/useGetConfigs';

export interface IConfigsContext {
  [p: string]: string | null;
}

export const ConfigsContext = createContext<IConfigsContext>({});

const ConfigsProvider: FC = (props) => {
  const { children } = props;
  const { data } = useGetConfigs();

  const value = useMemo(() => {
    return (
      data?.configs?.reduce<{ [p: string]: string | null }>(
        (configs, config) => {
          if (config?.key) {
            configs[config?.key] = config?.value;
          }
          return configs;
        },
        {},
      ) ?? {}
    );
  }, [data]);

  return (
    <ConfigsContext.Provider value={value}>{children}</ConfigsContext.Provider>
  );
};

export default ConfigsProvider;
